import React from 'react';
import ContentWithNavigationSidebar from '../legacy/layouts/ContentWithNavigationSidebar';
import Dashboard from '../legacy/pages/Dashboard';
import ROUTE_PATHS from './routePaths';

const routes = [
  {
    authenticatedRoute: true,
    path: ROUTE_PATHS.DASHBOARD,
    component: p => (
      <ContentWithNavigationSidebar>
        <Dashboard {...p} />
      </ContentWithNavigationSidebar>
    ),
  },
];
export default routes;



// WEBPACK FOOTER //
// ./src/routes/dashboardRoutes.jsx